import { GuessedLocation } from 'api/currentUser';
import { getItem } from 'utils/localStorage';

export function getInitialSearchLocation(
  guessedLocation: GuessedLocation
): SearchLocation {
  return (
    getItem('searchLocation') || {
      ...guessedLocation,
      geoType: 'ipAddress',
      boundingBoxN: null,
      boundingBoxS: null,
      boundingBoxW: null,
      boundingBoxE: null,
    }
  );
}
